module.exports = __webpack_public_path__ + "img/star-of-life.991ad627.svg";